module.exports = __webpack_public_path__ + "static/media/03-usa.44d2b298.png";